module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rollBanner"
  }, [_c('ul', {
    staticClass: "imgList"
  }, _vm._l((_vm.data), function(itme, index) {
    return _c('li', {
      class: index == _vm.imgAcNum ? 'liAc' : '',
      on: {
        "click": function($event) {
          return _vm.imgListAcFn(itme)
        }
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": itme.imgUrl
      }
    })])])
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "Buttons"
  }, _vm._l((_vm.data), function(itme, index) {
    return _c('li', [_c('span', {
      staticClass: "but",
      class: index == _vm.imgAcNum ? 'butAc' : '',
      on: {
        "click": function($event) {
          return _vm.butFn(index)
        }
      }
    })])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18886ec2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/rollBanner/src/rollBanner.vue
// module id = 508
// module chunks = 0